import { useContext, useLayoutEffect, useRef, useState } from "react";
import { BurgerButtonBig, ButtonRound, DropdownInfo, HeaderBig, LearnMore, SignupBox } from "../common/Common";
import './Diversity.css';
import { LocaleContext } from "../common/App";
import { Footer } from "./WebsiteCommon";
import { useIndexUpdate } from "../common/hooks";

export function Diversity(props) {
    const locale = useContext(LocaleContext);

    useIndexUpdate(props.indexUpdate, locale);

    return (
        <div className="diversity head_img">
            <img className="img_width" src="/customer/images/diversity_1.jpg" alt={locale.msgs.DIVERSITY_IMG_1_ALT_TEXT}></img>
            <div className="text_box margin_bottom_high">
                <h1 className="text_big_big head_after_img">{locale.msgs.DIVERSITY}</h1>
                <div className="text" dangerouslySetInnerHTML={{__html: locale.msgs.DIVERSITY_DESCR}}></div>
            </div>

            <Footer />
        </div>
    );
}
